import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import CorpListExcelRegisterFilePopup from './corp-list-excel-register-file-popup';
import CorpListStore from './corp-list-store';
import * as XLSX from 'xlsx';

const CorpListExcelRegisterFilePopupContainer = ({ location }) => {
  // console.log('CorpListExcelRegisterFilePopupContainer Load');

  const { visibleExcelRegisterFilePopup } = CorpListStore;
  const [fileInfo, setFileInfo] = useState([]);

  useEffect(() => {
    // console.log('CorpListExcelRegisterFilePopupContainer > useEffect()');
  }, [fileInfo]);

  const onClickInsertFile = useCallback(() => {
    if (fileInfo && fileInfo.length > 0) {
      const file = fileInfo[0];
      const ext = file.name.split('.').pop().toLowerCase();

      if (ext === 'xls' || ext === 'xlsx') {
        const reader = new FileReader();
        reader.onload = async (evt) => {
          const bstr = evt.target.result;
          const workBook = XLSX.read(bstr, { type: 'binary' });
          const workSheetName = workBook.SheetNames[0];
          const workSheet = workBook.Sheets[workSheetName];

          // const jsonData = XLSX.utils.sheet_to_json(workSheet);
          // console.log(jsonData);

          const range = XLSX.utils.decode_range(workSheet['!ref']);
          // console.log(range);

          let dataArray = [];

          for (let r = 3; r <= range.e.r; r++) {
            dataArray.push({
              LineNumber: workSheet[XLSX.utils.encode_cell({ c: 0, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 0, r: r })].v
                    .toString()
                    .replaceAll('-', '')
                : '',
              Name: workSheet[XLSX.utils.encode_cell({ c: 1, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 1, r: r })].v
                : '',
              Dong: workSheet[XLSX.utils.encode_cell({ c: 2, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 2, r: r })].v
                : '',
              Address: workSheet[XLSX.utils.encode_cell({ c: 3, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 3, r: r })].v
                : '',
              Part: workSheet[XLSX.utils.encode_cell({ c: 4, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 4, r: r })].v
                : '',
              Duty: workSheet[XLSX.utils.encode_cell({ c: 5, r: r })]
                ? workSheet[XLSX.utils.encode_cell({ c: 5, r: r })].v
                : '',
              UseCheck: workSheet[XLSX.utils.encode_cell({ c: 6, r: r })]
                ? isNaN(workSheet[XLSX.utils.encode_cell({ c: 6, r: r })].v)
                  ? 0
                  : parseInt(
                      workSheet[XLSX.utils.encode_cell({ c: 6, r: r })].v
                    ) > 2 ||
                    parseInt(
                      workSheet[XLSX.utils.encode_cell({ c: 6, r: r })].v
                    ) < 0
                  ? 0
                  : parseInt(
                      workSheet[XLSX.utils.encode_cell({ c: 6, r: r })].v
                    )
                : 0,
              UseCheckValue: workSheet[XLSX.utils.encode_cell({ c: 7, r: r })]
                ? isNaN(workSheet[XLSX.utils.encode_cell({ c: 7, r: r })].v)
                  ? 0
                  : parseInt(
                      workSheet[XLSX.utils.encode_cell({ c: 7, r: r })].v
                    )
                : 0,
            });
          }

          dataArray = dataArray.filter((data) => data.LineNumber !== '');
          dataArray = await Promise.all(
            dataArray.map(async (data) => {
              var userInfo = await CorpListStore.getUserInfo(data.LineNumber);
              return {
                ...data,
                CustomerCode: userInfo ? userInfo.CustomerCode : '',
                RegCheck: isNaN(data.LineNumber)
                  ? 2 // 잘못된 전화번호
                  : dataArray.findIndex(
                      (x) => x.LineNumber === data.LineNumber
                    ) !==
                    dataArray.length -
                      1 -
                      dataArray
                        .slice()
                        .reverse()
                        .findIndex((x) => x.LineNumber === data.LineNumber)
                  ? 3 // 중복된 전화번호
                  : userInfo && userInfo.Type === '2'
                  ? 4 // 기존등록법인
                  : !data.Name || data.Name === ''
                  ? 5 // 이름미입력
                  : !data.Part || data.Part === ''
                  ? 6 // 부서미입력
                  : !data.Duty || data.Duty === ''
                  ? 7 // 직책미입력
                  : userInfo
                  ? 1 // 기존고객
                  : 0, // 신규고객
                RegCheckName: isNaN(data.LineNumber)
                  ? '등록불가(잘못된전화번호)'
                  : dataArray.findIndex(
                      (x) => x.LineNumber === data.LineNumber
                    ) !==
                    dataArray.length -
                      1 -
                      dataArray
                        .slice()
                        .reverse()
                        .findIndex((x) => x.LineNumber === data.LineNumber)
                  ? '등록불가(중복된전화번호)'
                  : userInfo && userInfo.Type === '2'
                  ? '등록불가(기존등록법인)'
                  : !data.Name || data.Name === ''
                  ? '등록불가(이름미입력)'
                  : !data.Part || data.Part === ''
                  ? '등록불가(부서미입력)'
                  : !data.Duty || data.Duty === ''
                  ? '등록불가(직책미입력)'
                  : userInfo
                  ? '등록가능(기존고객)'
                  : '등록가능(신규고객)', // 정상
                UseCheckName:
                  data.UseCheck === 1
                    ? '금액'
                    : data.UseCheck === 2
                    ? '횟수'
                    : '회사내규',
                UserCheckValue: data.UseCheck === 0 ? 0 : data.UseCheckValue,
                UseCheckValueName:
                  data.UseCheck === 1
                    ? data.UseCheckValue + '원'
                    : data.UseCheck === 2
                    ? data.UseCheckValue + '회'
                    : '',
              };
            })
          );

          if (dataArray.length > 0) {
            CorpListStore.setVisibleExcelRegisterListPopup(true, dataArray);
          } else {
            alert('등록할 사용자가 없습니다.');
          }
        };
        reader.readAsBinaryString(file);
      } else {
        alert('엑셀(.xls|.xlsx)파일만 업로드 할수 있습니다.');
      }
    } else {
      alert('파일을 선택해 주시기 바랍니다.');
    }
  }, [fileInfo]);

  const onValueChangedUploadFile = useCallback((e) => {
    console.log(e);

    if (e.value.length > 0) {
      setFileInfo(e.value);
    }
  }, []);

  return (
    <CorpListExcelRegisterFilePopup
      onHiding={() => {
        setFileInfo([]);
        CorpListStore.setVisibleExcelRegisterFilePopup(false);
      }}
      onClickInsertFile={onClickInsertFile}
      onValueChangedUploadFile={onValueChangedUploadFile}
      setFileInfo={setFileInfo}
      fileInfo={fileInfo}
      visibleExcelRegisterFilePopup={visibleExcelRegisterFilePopup}
    />
  );
};

export default React.memo(
  withRouter(observer(CorpListExcelRegisterFilePopupContainer))
);
